import clsx from "clsx";
import React, { useCallback, useState } from "react";
import * as styles from "./InlineLeadForm.module.scss";

import { DefaultSubscribeFormProps } from "components/DefaultSubscribeForm/DefaultSubscribeForm";
import {
  BlockContentValue,
  PartialSanityImageType,
  ResponsiveSanityImage,
  SanityImageRatio
} from "@silversea-ssc/ui-components-react";
import ThankYouBox from "./ThankYoyBox";
import { FormDisclaimerFragment } from "types/graphql-types";
const DefaultSubscribeForm = React.lazy(
  () => import("components/DefaultSubscribeForm/DefaultSubscribeForm")
);

type InlineLeadFormProps = Pick<
  DefaultSubscribeFormProps,
  "formName" | "askPhone" | "requestSource" | "requestType" | "dataContentName"
> & {
  thankYouContentTitle: string | undefined;
  thankYouContentText: BlockContentValue | undefined;
  image: PartialSanityImageType | undefined;
  inputColor: "neutral05" | "white";
  formDisclaimerContent: FormDisclaimerFragment | undefined;
};

const InlineLeadForm: React.FC<InlineLeadFormProps> = ({
  formName,
  askPhone,
  requestSource,
  requestType,
  dataContentName,
  image,
  inputColor,
  thankYouContentTitle,
  thankYouContentText,
  formDisclaimerContent
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const onSubmitSuccess = useCallback(() => {
    setIsSubmitted(true);
  }, []);

  const formArgs = {
    formName,
    onSubmitSuccess,
    requestSource,
    requestType,
    askImNotTraveAgent: false,
    enableSubscribeEmail: true,
    askWorkWithAgent: false,
    askPhone,
    phoneIsRequired: false,
    askAddress: false,
    askDescription: false,
    dataContentName
  };

  return (
    <div className={styles.row}>
      <div className={styles.aside}>
        {image && (
          <SanityImageRatio image={image} ratio="auto" className={styles.image}>
            <ResponsiveSanityImage
              image={image}
              defaultWidth={360}
              defaultHeight={300}
              fit="crop"
            />
          </SanityImageRatio>
        )}
      </div>
      <hr className={styles.separator} />
      <div className={clsx(styles.content)}>
        {isSubmitted ? (
          <ThankYouBox
            title={thankYouContentTitle}
            content={thankYouContentText}
          />
        ) : (
          <React.Suspense fallback={<div></div>}>
            <DefaultSubscribeForm
              className={clsx(styles.form, {
                [styles.inputWhite]: inputColor == "white"
              })}
              formDisclaimerContent={formDisclaimerContent}
              {...formArgs}
            />
          </React.Suspense>
        )}
      </div>
    </div>
  );
};

export default InlineLeadForm;
